//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
import SquareButton from './square-button.vue';
import {isoDateFormat} from '../time-utils.js';
import {isSubtask} from '../utils.js';
import {
  bulkRescheduleAtEnd,
  removePlannedFor,
} from '../ordered-relation.js'

export default {
  components: {
    SquareButton,
  },
  data() {
    const now = moment();
    return {
      menuOpen: false,
      todayIso: now.clone().startOf('day').format(isoDateFormat),
      tomorrowIso: now.clone().startOf('day').add(1, 'day').format(isoDateFormat),
      thisWeekIso: now.clone().startOf('isoWeek').format(isoDateFormat),
      nextWeekIso: now.clone().startOf('isoWeek').add(1, 'week').format(isoDateFormat),
      thisMonth: now.clone().startOf('month').format(isoDateFormat),
    };
  },
  computed: {
    noBacklogByDefault() {
      return this.$settings && this.$settings.backlogByDefault !== true;
    },
  selectedTasks() {
    return this.$taskCardsController.selectedTasks();
  },
  },
  methods: {
    scheduleFor(parentClass, parentKey) {
      this.$reactiveCache.freezeUntil(
        bulkRescheduleAtEnd({
          reactiveCache: this.$reactiveCache,
          tasks: this.selectedTasks,
          newPPtr: {parentClass, parentKey},
        })
      );
    },
    scheduleForList(listID) {
      this.$reactiveCache.freezeUntil(
        bulkRescheduleAtEnd({
          reactiveCache: this.$reactiveCache,
          tasks: this.selectedTasks,
          newPPtr: {parentClass: 'list', parentKey: listID},
        })
      );
    },
    unplan() {
    for (const task of this.selectedTasks) {
        removePlannedFor(task)
      }
      this.$taskCardsController.leaveSpecialState();
    },
  },
};
